import { LOGOUT, LogoutActionType } from "~/store/auth/types";


export function logout(): LogoutActionType {
  return {
    type: LOGOUT,
  };
}
